import { LanguageDetector } from "./language-detector";

export { LanguageDetector };
